import AppStore from './appStore';
import DataStore from './dataStore';
import MapStore from './mapStore';


export {
    AppStore,
    DataStore,
    MapStore,
};


class RootStore {
    constructor() {
        this.appStore = new AppStore(this);
        this.dataStore = new DataStore(this);
        this.mapStore = new MapStore(this);

    }
}
const rootStore = new RootStore();
export default rootStore;